/**
 * Created by karora on 12/03/17.
 */
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { ApiService } from '../services/api.service';
import { HubSearchService } from '../services/hub-search.service';
import { HubService } from '../services/hub.service';
import { ProfileService } from '../services/profile.service';
import { Hub } from '../types/hub';
import { StandardResponse } from '../types/standard-response';

@Component({
  selector: 'hub-search',
  template: `<div id="search_component">
  <div *ngIf="errorMessage; else noErrors" id="error" class="mat-error">{{errorMessage}}</div>
  <ng-template #noErrors>
    <input #searchBox id="search_box" (keyup)="search(searchBox.value)" placeholder="Search..."/>
    <div id="search_results" class="search_results">
      <div *ngFor="let hub of hubs | async"
           (click)="gotoDetail(hub.hubid)"
           class="search_result" >
        <span class="hubid">{{hub.hubid}}</span>
        <span class="name">{{hub.name}}</span>
        <span class="machineid">{{hub.machineid}}</span>
      </div>
    </div>
  </ng-template>
</div>`,
  styleUrls: [ './hub-search.component.css' ],
  providers: [HubSearchService]
})

export class HubSearchComponent implements AfterViewInit {
  @ViewChild('searchBox') searchBox: ElementRef;
  private canSearch: boolean;
  hubs: Observable<Hub[]>;
  private searchTerms = new Subject<string>();
  errorMessage = '';

  constructor(
    private hubSearchService: HubSearchService,
    private hubService: HubService,
    private router: Router) {}

  // Push a search term into the observable stream.
  search(term: string): void {
    let hubID = Hub.SerialToHubID(+term);
    if (hubID > 100) {
      this.gotoDetail(hubID);
    } else {
      this.searchTerms.next(term);
    }
  }

  ngOnInit(): void {
    this.canSearch = ProfileService.CanAdminister();
  }

  ngAfterViewInit(): void {
    this.resetSearch();
  }

  resetSearch(): void {
    if (this.searchBox && this.searchBox.nativeElement) {
      let searchInput = this.searchBox.nativeElement as HTMLInputElement;
      searchInput.value = '';
    }
    console.log(this.searchBox);
    this.hubs = this.searchTerms.asObservable().pipe(
      debounceTime(300),        // wait 300ms after each keystroke before considering the term
      distinctUntilChanged(),   // ignore if next search term is same as previous
      switchMap((term: string) => term && term.length > 2   // switch to new observable each time the term changes
        // return the http search observable
        ? this.hubSearchService.search(term)
        // or the observable of empty hubs if there was no search term, or it was less than three characters
        : of(<Hub[]>([]))),
      catchError((error: { error: StandardResponse; status: number; }) => {
        // TODO: add real error handling
        if (error.error && error.status) {
          let response = error.error as StandardResponse;
          console.log('Fix error handling:' + JSON.stringify(response, null, 2));
          if (error.status === 401) {
            this.errorMessage = 'Unauthorized!';
            ApiService.AuthenticationExpired();
          } else {
            this.errorMessage = `The server returned a ${error.status} error code.`;
          }
        } else {
          this.errorMessage = 'An unexpected error occurred!';
          console.log('Fix error handling:' + JSON.stringify(error, null, 2));
        }
        return of(<Hub[]>([]));
      }));
  }

  gotoDetail(hubid: number): void {
    let link = ['/hub', hubid];
    this.resetSearch();
    this.router.navigate(link);
  }

}
